<div class="liner">
  <div class="ttl_form">{{ headerText }}</div>
  <div *ngFor="let member of memberList; let i = index">
    <div class="d-flex p-5-0" [attr.data-index]="i">
      <div *ngIf="allowEditMemberList" class="d-flex a-i-center">
        <a class="delete-members" (click)="deleteButtonClick(member)"></a>
      </div>
      <div class="d-flex a-i-center">
        <div class="word-break-b-w">
          {{ member.fullName }}
        </div>
      </div>
      <div *ngIf="showPercentage" class="percent m-l-a w-s-nw">
        <input
          id="percentages"
          type="number"
          class="w-25-px"
          min="0"
          max="100"
          [readonly]="!allowEditPercentage"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="member.partInProject"
        />
      </div>
    </div>
  </div>
  <a *ngIf="allowEditMemberList" class="add_soauth mini_add" (click)="addButtonClick()">
    {{ addButtonText }}
  </a>
</div>
